export default __webpack_public_path__ + "static/media/f_logo_no_text.f6ecb290.png";